module.exports = __webpack_public_path__ + "static/media/Biohazard.1ba29f65.svg";